import { render, staticRenderFns } from "./shareBusinessCard.vue?vue&type=template&id=ec0c9ffe&scoped=true"
import script from "./shareBusinessCard.vue?vue&type=script&lang=js"
export * from "./shareBusinessCard.vue?vue&type=script&lang=js"
import style0 from "./shareBusinessCard.vue?vue&type=style&index=0&id=ec0c9ffe&prod&scoped=true&lang=css"
import style1 from "./shareBusinessCard.vue?vue&type=style&index=1&id=ec0c9ffe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0c9ffe",
  null
  
)

export default component.exports